import { render } from "./ImportGroupForm.vue?vue&type=template&id=439e8034&scoped=true&ts=true"
import script from "./ImportGroupForm.vue?vue&type=script&lang=ts"
export * from "./ImportGroupForm.vue?vue&type=script&lang=ts"

import "./ImportGroupForm.vue?vue&type=style&index=0&id=439e8034&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439e8034"]])

export default __exports__